import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useProfile } from '../contexts/ProfileContext';
import DashboardLayout from '../components/DashboardLayout';
import ProfileStats from '../components/ProfileStats';
import QuickActions from '../components/QuickActions';
import RecentActivity from '../components/RecentActivity';
import ConnectionTest from '../components/ConnectionTest';
import QRCodeGenerator from '../components/QRCodeGenerator';
import EnhancedAnalytics from '../components/EnhancedAnalytics';
import QRScanner from '../components/QRScanner';

const DashboardPage = () => {
  const { isAuthenticated, loading: authLoading } = useAuth();
  const { profile, loading: profileLoading } = useProfile();
  const navigate = useNavigate();
  const [showQRScanner, setShowQRScanner] = useState(false);

  useEffect(() => {
    if (!authLoading && !isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, authLoading, navigate]);

  if (authLoading || profileLoading) {
    return (
      <DashboardLayout>
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-lime-500"></div>
        </div>
      </DashboardLayout>
    );
  }

  if (!profile) {
    return (
      <DashboardLayout>
        <div className="text-center py-12">
          <h2 className="text-2xl font-bold text-white mb-4">
            Welcome to HubID!
          </h2>
          <p className="text-gray-400 mb-8">
            Let's set up your profile to get started.
          </p>
          <Link
            to="/profile"
            className="glass-lime text-lime-400 px-6 py-3 rounded-lg font-medium hover:text-lime-300 transition-colors border border-lime-500/50 hover:border-lime-400/70 shadow-glow-lime-sm inline-block"
          >
            Create Profile
          </Link>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="space-y-8">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h1 className="text-2xl font-bold text-white">
              Welcome back, {profile.display_name || profile.username}!
            </h1>
            <p className="text-gray-400 mt-1">
              Manage your Web3 identity and track your performance
            </p>
          </div>
          <div className="mt-4 sm:mt-0">
            <Link
              to={`/u/${profile.username}`}
              target="_blank"
              rel="noopener noreferrer"
              className="glass inline-flex items-center px-4 py-2 rounded-lg text-sm font-medium text-white hover:text-lime-400 transition-colors border border-white/10 hover:border-lime-500/50"
            >
              View Public Profile
            </Link>
          </div>
        </div>

        {/* Stats */}
        <ProfileStats profileId={profile.id} />

        {/* QR Code */}
        <QRCodeGenerator username={profile.username} />

        {/* Enhanced Analytics */}
        <EnhancedAnalytics profileId={profile.id} />

        {/* Connection Tests */}
        <ConnectionTest />

        {/* Quick Actions */}
        <QuickActions profile={profile} />

        {/* Recent Activity */}
        <RecentActivity profileId={profile.id} />
      </div>
    </DashboardLayout>
  );
};

export default DashboardPage;
